import React from 'react';

export default ({ className, name, size, colored, ...rest }) => {
  let style = {};
  if (size) {
    style = {
      ...style,
      fontSize: size,
      fontFamily: 'icons'
    };
  }
  return (
    <i
      className={`icon icon-${name} icon-${colored ? 'colored' : 'solid'} ${
        className ? className : ''
      }`}
      style={style}
      {...rest}
    />
  );
};
